__turbopack_context__.v({
  "fullBleed": "OverviewTabNav-module__dnn_Aa__fullBleed",
});
